export default "__VITE_ASSET__bc3d17c7__"